import { formatDateTextShort } from "utils/formatDate";
import API, {newAPI} from "../authentication/AuthInterceptor";

export class DashboardService {
  
  today = new Date();
  firstDayOfYear = new Date(this.today.getFullYear(), 0, 1);

  async getDashboardData(fromDate?: string, toDate?: string) {
    const response = await API.get(`/distributor/28e408fe-8d09-43bf-b8c1-5f8961d926a4/statistics${fromDate ? `?fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`);

    const updatedResponse = {
      ...response.data,
      marketplaceImpressionsGraph: response.data.marketplaceImpressionsGraph.map(
        ({ impressions, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value: impressions
        })
      ),
      revenueGraph: response.data.revenueGraph.map(
        ({ revenuePartner, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value: revenuePartner
        })
      )
    };
    return updatedResponse;
  }

  async getDashboardMerchants(fromDate?: string, toDate?: string) {
    const response = await API.get(`/distributor/merchants/dashboard${fromDate ? `?fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`);
    return response.data.merchants;
  }

  async getDashboardDataByPeriod(fromDate?: string, toDate?: string) {
    const response = await API.get(`/distributor/dashboard${fromDate ? `?fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`);
    
    const updatedResponse = {
      ...response.data.body,
      impressionTrend: response.data.body.impressionTrend.map(
        ({ value, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value: value
        })
      ),
      revenueTrend: response.data.body.revenueTrend.map(
        ({ value, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value: value
        })
      )
    }; 

    return updatedResponse;
  }

}
